import { Koi } from '@ksyos/koi';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';
import { SleepRecorderType } from './sleepRecorderType';

export type OsasRequestAdditionalExaminationData = {
    reasonChanged: string | null;
    sleepRecorderType: SleepRecorderType | null;
};

export const osasAdditionalExaminationDraftSchema = Koi.object({
    reasonChanged: getTextAreaStringSchema(true, 255),
    sleepRecorderType: Koi.koi().enum(SleepRecorderType).allow(null),
});

export const osasAdditionalExaminationFinalSchema = Koi.object({
    reasonChanged: getTextAreaStringSchema(false, 255),
    sleepRecorderType: Koi.koi().enum(SleepRecorderType),
});
